import { createConfigSection } from '../helpers'

export default {
    ...createConfigSection('api', {
        base: 'https://beheer-testruimte-api.agressieregistratieoverheid.nl',
        requestTimeout: 2000
    }),

    ...createConfigSection('oidc', {
        authority: 'https://backend-urk2js6j5rxi4.azurewebsites.net',
        post_logout_redirect_uri: 'https://beheer-testruimte.agressieregistratieoverheid.nl'
    })
}
